import React from 'react';
import { Breakpoint, useBreakpoint } from 'src/hooks/useBreakpoint';
import { SummaryInfo } from 'src/components/Basket/SummaryInfo';

import { Svg } from '../Svg/Svg';
import { RichText } from '../RichText/RichText';

import classes from './InfoBlock.scss';

type Props = {
    content?: string;
};

export const InfoBlock: React.FC<Props> = ({ content }) => {
    const [breakpoint] = useBreakpoint();
    return (
        <>
            <div className={classes.infoBlock}>
                <h4 className={classes.infoBlockTitle}>
                    <Svg name="promise" color="success" /> Add your logo with confidence
                </h4>
                <p className={classes.infoBlockDesc}>
                    Our in-house design team based in Durham, UK{' '}
                    <img src={require('../../../static/icons/british_flag.png')} alt="UK Flag" /> will send you a proof
                    of your logo/text for you to approve before we begin production.
                    <br />
                    <br />
                    <b>Please note:</b> Existing artwork will not be proofed out again as approval from your previous
                    artwork proof from this design will be used.
                </p>
                {content && (
                    <div className={classes.infoBlockContent}>
                        <RichText content={content} />
                    </div>
                )}
            </div>

            {breakpoint === Breakpoint.Mob && <SummaryInfo />}
        </>
    );
};
